/* @flow */
import cx from 'classnames';
import { Container } from 'flux/utils';
import GroupStore from 'groups/stores/GroupStore';
import Groups from 'collections/Groups';
import PrintAnnouncements from './PrintAnnouncements.jsx';
import PrintSubscribers from './PrintSubscribers.jsx';
import * as React from 'react';
import Divider from 'components/Divider.jsx';

type State = {
  groups: Groups,
};

class PrintSettingsView extends React.Component<$FlowFixMeProps, State> {
  static getStores() {
    return [GroupStore];
  }

  static calculateState() {
    return {
      groups: GroupStore.getOwnedGroups(),
    };
  }

  render() {
    return (
      <div className={cx('PrintSettingsView', this.props.className)}>
        <PrintAnnouncements groups={this.state.groups} />
        <Divider />
        <PrintSubscribers groups={this.state.groups} />
      </div>
    );
  }
}

export default Container.create(PrintSettingsView);
